import type { LeaderboardMetric } from "@expert/app-config/types";

import { getGamificationApiClient } from "../../home-product/api/api";
import { getLeaderboardTimeframe } from "./getLeaderboardTimeframe";

export interface LeaderboardEntry {
    employeeId: string;
    employeeName: string;
    score: number;
    order: number;
}

export const getCurrentLeaderboard = async (metric: LeaderboardMetric, sku?: string): Promise<LeaderboardEntry[]> => {
    const { start, end } = getLeaderboardTimeframe();
    const searchParams: Record<string, string> = { start, end };
    if (sku) searchParams.productSku = sku;

    return await getGamificationApiClient()
        .get(`v2/leaderboards/${metric}`, { searchParams, retry: 0 })
        .json<LeaderboardEntry[]>();
};
